export { Badge } from "./Badge";
export type { BadgeProps, BadgeTone } from "./Badge";
